import { EnvVarManager } from '@/env/envVarManager';

export const getFakeAuthenticated = (): boolean => {
  return EnvVarManager.getEnvVar('NEXT_PUBLIC_FAKE_AUTHENTICATED');
};
